import React, { Component }      from 'react';
import {connect}                 from 'react-redux';
import Dropzone                  from 'react-dropzone';
import {Field, reduxForm, reset} from 'redux-form';
import validate                  from '../../../service/validate_nave';
import renderField               from '../../../container/renderFieldTextArea';
import {SendPublic,
        SetValidUrlYoutube,
        ClearUrl,
        GetRegistroPostEquipe}   from '../../../actions/grupoAction';
import { SetError }              from '../../../actions/notificacaoAction';
import RenderPrevImg             from '../../../container/renderPrevImagemTimeLine'; 
import RenderFormTextVideo       from '../../../container/renderFormTextVideo';

class Equipe_Aluno_Post_form extends Component {

    constructor(props){
        super(props)
        this.state = {
            publicImg        : false,
            publicMov        : false,
            buttonDisabled   : false,
            validMov         : false,
            publicText       : "",
            video            : "",
            errors           : {},
            use_id           : this.props.session.id,
            per_id           : this.props.session.perfil,
            equ_id           : this.props.equ_id,
            post_tipo        : 1,
            files            : null,
            textButtonPublic : "Publicar"
        }

        this.onChange      = this.onChange.bind(this);
        this.onChangeVideo = this.onChangeVideo.bind(this);
        this.PublicMovie   = this.PublicMovie.bind(this);
    }

    onDrop(files) {
     this.setState({selectedImg:files[0].preview,files:files,publicImg:true,publicMov:false,post_tipo:2});
    }

    removeImgSelect(){
     this.setState({selectedImg:[],publicImg:false,post_tipo:1, files: null})
    }

    removeMovSelect(){
     this.setState({publicMov:false,post_tipo:1,video: "",validMov:false})
    }

    PublicMovie(){
     this.setState({publicMov:true,publicImg:false});
    }

    onChange(e) {
     this.setState({publicText: e.target.value,errors:{}});
    }

    onChangeVideo(e) {
        const retValid =  this.props.SetValidUrlYoutube(e.target.value);
        this.setState({ 
                        video     : (retValid === 1 ? e.target.value:""),
                        validMov  : (retValid === 1 ? false:true),
                        post_tipo : (retValid === 1 ? 3:1)
                      });
    }

    statesComponente(){
      this.setState({ textButtonPublic:"Publicar",buttonDisabled:false,publicText:"",validMov:false});
    }

    handleSubmit(e){
            this.setState({ textButtonPublic:"Enviando...",buttonDisabled:true});
            const dados   = {
                                equ_pos_cod_equipe  : this.state.equ_id,
                                equ_pos_cod_usuario : this.state.use_id,
                                equ_pos_tipo        : this.state.post_tipo,
                                equ_pos_midia       : (this.state.post_tipo === 3 ? this.props.ClearUrl(e.video) : "" ),
                                equ_pos_post        : e.publicText
                            }
            this.props.SendPublic(dados,this.state.files).then((response) =>{
                    this.statesComponente();
                    this.removeMovSelect();
                    this.removeImgSelect(); 
                }).catch((error)=>{
                    this.statesComponente();
                    this.props.SetError(500);
                });
    }
   
    render() {
      
        const {handleSubmit} = this.props;

        return (
                <div className="timeline-panel clearfix">
                    <form onSubmit={handleSubmit(this.handleSubmit.bind(this))}>
                    <div className="timeline-body">
                        <Field name="publicText" type="textarea" component={renderField} label="" placeholder="Criar uma publicação"/>
                        {this.state.publicImg ? <RenderPrevImg prevImg={this.state.selectedImg} funcao={this.removeImgSelect.bind(this)}/>:""} 
                        {this.state.publicMov ? <Field name="video" type="text" component={RenderFormTextVideo} placeholder="Criar uma publicação" funcao={this.removeMovSelect.bind(this)} onChange={this.onChangeVideo}/>:""}
                        {this.state.validMov  ? <span className="text-danger"> <h6>Copie e cole uma url válida do Youtube.</h6> </span> : ""}
                    </div>
                    <div className="timeline-panel-footer timeline-foot-comments">
                        <Dropzone className="btn btn-default btn-xs" multiple={false} accept="image/png,image/jpeg" onDrop={this.onDrop.bind(this)}>
                            <div><span className="glyphicon glyphicon-camera"></span></div>
                        </Dropzone> 
                        <button type="button" className="btn btn-default btn-xs" onClick={this.PublicMovie}>
                             <span className="glyphicon glyphicon-facetime-video"></span>
                        </button>
                        <button  type="submit" className="btn btn-primary btn-xs pull-right" disabled={this.state.buttonDisabled}>
                             <span className="glyphicon glyphicon-send"  aria-hidden="true"></span> {this.state.textButtonPublic}
                        </button> 
                    </div>
                    </form>
                </div>
                );
    }
}

const afterSubmit = (result, dispatch) => dispatch(reset('post_equipe'));
function mapStateToProps(state){
    return{
           session : state.auth.session,
           equipe  : state.equipeReducer.nome_equipe
          }
}

export default reduxForm({
   form                     : 'post_equipe',
   destroyOnUnmount         : true,
   forceUnregisterOnUnmount : true,
   onSubmitSuccess          : afterSubmit,
  validate
})(connect(mapStateToProps,{SendPublic,SetValidUrlYoutube,ClearUrl,SetError,GetRegistroPostEquipe})(Equipe_Aluno_Post_form));



// WEBPACK FOOTER //
// ./src/components/professor/timeline_equipe/equipe_aluno_post_form.js